export const CHECKOUT_CREATE = 'checkoutCreate'
export const CHECKOUT_EDIT = 'checkoutEdit'
export const CHECKOUT_DELETE = 'checkoutDelete'
export const CHECKOUT_GET = 'checkoutGet'
export const CHECKOUTS_GET = 'checkoutsGet'
export const CHECKOUTS_BM_GET = 'checkoutsBMGet'
export const CHECKOUT_SEARCH = 'checkoutSearch'
export const CHECKOUT_ACTIVE = 'checkoutActive'
export const CHECKOUT_INACTIVE = 'checkoutInactive'
export const CHECKOUT_STATUS_LIST_GET = 'checkoutStatusListGet'
export const CHECKOUT_SCHEDULES_GET = 'checkoutSchedulesGet'
export const CHECKOUT_SCHEDULE_GET = 'checkoutScheduleGet'
export const CHECKOUT_CHARGE = 'checkoutCharge'